import { useQuery } from '@tanstack/react-query';

import { roleTypes } from '../types';

import { axios } from '@/libraries/axios';
import { ExtractFnReturnType, QueryConfig } from '@/libraries/react-query';

export const getPermissions: roleTypes.GetPermissions = () => {
  return axios.get('/permissions');
};

type QueryFnType = typeof getPermissions;

type UseGetPermissionsOptions = {
  config?: QueryConfig<QueryFnType>;
};

export const useGetPermissions = ({ config = {} }: UseGetPermissionsOptions = {}) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['permissions'],
    queryFn: getPermissions,
  });
};
